// NPM packages
import React from 'react';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

import { firstSentence } from 'components/core/FundingStatement';

// All other imports

const Root = styled.div(({ theme: { palette } }) => ({
  backgroundColor: palette.primary.dark,
  color: palette.common.white,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
}));

const DisplayArea = styled.div(({ theme }) => {
  return `
    min-width: ${theme.maxToolWidth};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: ${theme.typography.pxToRem(16)} ${theme.typography.pxToRem(87)};
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 1200px) {
      min-width: 0;
      width: 100%;
      padding: ${theme.typography.pxToRem(16)} ${theme.typography.pxToRem(43.5)};
    }

    @media (max-width: 600px) {
      padding: ${theme.typography.pxToRem(16)} 1rem;
    }
  `;
});

const Filler = styled.div({
  width: '33%',
  display: 'none',
});

const StatementText = styled.div(({ theme: { typography, palette } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: typography.fontWeightMedium,
  fontSize: '1rem',
  textAlign: 'center',
  '& a': {
    color: palette.grey['400'],
    '&:hover': {
      color: 'white',
    },
  },
}));

const Footnote = styled(Typography)(
  ({ theme: { palette, typography, breakpoints } }) => ({
    fontSize: '1rem',
  })
);

const LogoHolder = styled.div({
  width: '33%',
  display: 'flex',
  justifyContent: 'flex-end',
});

export interface FooterProps {
  className?: string;
}

export default function Footer(props: FooterProps): React.ReactElement | null {
  const { className } = props;
  return (
    <Root className={className}>
      <DisplayArea>
        <StatementText>
          <Footnote>{firstSentence}</Footnote>
        </StatementText>
      </DisplayArea>
    </Root>
  );
}
